<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "LookupCodeIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
